import { Injectable } from "@angular/core";
import { CryptoService } from "@core/services/crypto.service";
import packageJson from 'package.json';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly isDev = !environment.production;
  private readonly storageKey = packageJson.name + '_enc';
  private sessionMap = new Map<string, any>();

  constructor(private crypto: CryptoService) {
    const stored = sessionStorage.getItem(this.storageKey);

    if (stored) {
      const data = this.isDev
        ? stored
        : this.crypto.aesDecrypt(stored);

      this.sessionMap = new Map<string, any>(JSON.parse(data));
    }
  }

  private syncSession() {
    const serialized = [...this.sessionMap];
    const data = this.isDev ? JSON.stringify(serialized) : this.crypto.aesEncrypt(serialized);
    sessionStorage.setItem(this.storageKey, data);
  }

  setItem(key: string, value: any): void {
    this.sessionMap.set(key, value);
    this.syncSession();
  }

  getItem(key: string): any {
    if (!this.sessionMap.has(key)) {
      return undefined;
    }
    return this.sessionMap.get(key);
  }

  removeItem(key: string): void {
    if (this.sessionMap.delete(key)) {
      this.sessionMap.size > 0
        ? this.syncSession()
        : sessionStorage.removeItem(this.storageKey);
    }
  }

  clear(): void {
    this.sessionMap.clear();
    sessionStorage.removeItem(this.storageKey);
  }

  hasKey(key: string): boolean {
    return this.sessionMap.has(key);
  }
}
